module.exports = __webpack_public_path__ + "static/media/store_information_block_option_1.d21f4450.webp";